import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="flex min-h-screen items-center justify-center bg-black text-yaza-dim">…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
